module.exports = __webpack_public_path__ + "img/win_4.3eaec90e.png";